import { Dictionary } from '../../../shared/models/dictionary';
import { PartReplaceTypes } from '../enums/part-replace-types';

export const getPartReplaceTypes = () => [
  { id: PartReplaceTypes.REPLACEMENTS, name: 'Jest zastąpiona' },
  { id: PartReplaceTypes.REPLACES, name: 'Zastępuje' },
] as Dictionary[];
